import ProgramTabs from'./ProgramTabs';export default ProgramTabs;